import React from 'react';
import { Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="bg-black border-t border-white/10 pt-24 pb-12 px-6" data-id="element-32">
      <div className="max-w-7xl mx-auto" data-id="element-33">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-24" data-id="element-34">
          <div className="col-span-1 md:col-span-2" data-id="element-35">
            <h2 className="text-5xl md:text-7xl font-black text-white tracking-tighter mb-8" data-id="element-36">
              LET'S WORK <br data-id="element-37" />
              <span className="text-yellow-400" data-id="element-38">TOGETHER</span>
            </h2>
            <a href="mailto:hello@kujodo.id" className="text-xl md:text-2xl text-gray-400 hover:text-white transition-colors border-b border-gray-800 hover:border-white pb-1" data-id="element-39">
              hello@kujodo.id
            </a>
          </div>

          <div data-id="element-40">
            <h4 className="text-white font-bold uppercase tracking-widest mb-6" data-id="element-41">
              Studio
            </h4>
            <address className="text-gray-400 not-italic space-y-2" data-id="element-42">
              <p data-id="element-43">Komplek Bumi Parahyangan Cimahi Blok N6</p>
              <p data-id="element-44">Kel. Cibeber, Kec. Cimahi Selatan</p>
              <p data-id="element-45">Kota Cimahi</p>
            </address>
          </div>

          <div data-id="element-46">
            <h4 className="text-white font-bold uppercase tracking-widest mb-6" data-id="element-47">
              Social
            </h4>
            <div className="flex space-x-4" data-id="element-48">
              <a href="https://instagram.com/kujodo.studio" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-white hover:bg-yellow-400 hover:text-black hover:border-yellow-400 transition-all" data-id="element-49">
                <Instagram size={18} data-id="element-50" />
              </a>
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center pt-8 border-t border-white/10 text-xs text-gray-600 uppercase tracking-widest font-bold" data-id="element-51">
          <p data-id="element-52">&copy; 2024 KUJODO Studio. All rights reserved.</p>
          <div className="flex space-x-8 mt-4 md:mt-0" data-id="element-53">
            <a href="#" className="hover:text-white transition-colors" data-id="element-54">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-55">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}